// extracted by mini-css-extract-plugin
export default {"popup":"Modal_popup_PgbCj","overlay":"Modal_overlay_wZ4AA","close":"Modal_close_kAV3S","content":"Modal_content_adDWf","body":"Modal_body_vYwLA","expand":"Modal_expand_T8iS1"};